import { useForm } from 'react-hook-form';
import { Typography, Stack, Button } from '@mui/material';
import { Form, SelectControl, useToast } from '@foxtaibox/foxtailbox-frontend-core';
import { GetUserQuery, Language, useSetCandidateLanguageMutation } from '@generated/graphql';
import { useTranslation } from 'react-i18next';
import { LanguageDataForm } from '../types';

interface UserDataProps {
  user: GetUserQuery['me'] | undefined;
}

const UserSettings = ({ user }: UserDataProps) => {
  const { t, i18n } = useTranslation();
  const { showErrorToast, showSuccessToast } = useToast();

  const form = useForm<LanguageDataForm>({
    values: {
      language: (user?.language as Language) || '',
    },
  });

  const { handleSubmit } = form;
  const [setCandidateLanguage, { loading }] = useSetCandidateLanguageMutation();

  const onSubmit = (formData: LanguageDataForm) => {
    const language = formData.language as Language;

    setCandidateLanguage({
      variables: { language },
    })
      .then(() => {
        i18n.changeLanguage(language);
        showSuccessToast(t('successMessage'));
      })
      .catch(() => showErrorToast(t('errors.common')));
  };

  return (
    <div>
      <Typography variant='h28' mt={3.75} mb={{ xs: 1.5, sm: 3 }}>
        {t('user.settingsTitle')}
      </Typography>
      <Form form={form}>
        <Stack spacing={3} mt={3} mb={3}>
          <SelectControl
            name='language'
            label={t('user.languageLabel')}
            items={[
              { label: 'Русский', value: Language.Ru },
              { label: 'Kазақша', value: Language.Kk },
              { label: 'English', value: Language.En },
              { label: "O'zbek", value: Language.Uz },
            ]}
          />
        </Stack>
      </Form>
      <Button
        variant='contained'
        size='large'
        fullWidth
        onClick={handleSubmit(onSubmit)}
        loading={loading}>
        {t('save')}
      </Button>
    </div>
  );
};

export default UserSettings;
